import {
  APP_VERSION,
  ConfigSettingsService,
  DeviceOrigin,
  FooterLinkCategory,
  MenuStage,
  NavigationLink,
  NavigationLinkRegistryService,
  groupBy,
} from '@ebeihilfe/core';
import { ChangeDetectionStrategy, Component, OnInit, WritableSignal, inject, signal } from '@angular/core';
import { FooterListComponent } from './footer-list/footer-list.component';
@Component({
  imports: [FooterListComponent],
  standalone: true,
  selector: 'portal-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit {
  private readonly _versionToken = inject(APP_VERSION);
  private readonly linkService = inject(NavigationLinkRegistryService);
  private readonly configService = inject(ConfigSettingsService);
  public appVersion: WritableSignal<string> = signal(this._versionToken.version);
  public buildNumber: WritableSignal<string> = signal(this._versionToken.buildNumber);
  public groupedFooterItems: WritableSignal<FooterItem[]> = signal([]);
  public onlyWeb: WritableSignal<boolean> = signal(this.configService.appSettings.onlyWeb);

  public async ngOnInit(): Promise<void> {
    const footerItems = await this.linkService.getFooterLinks(MenuStage.INIT, DeviceOrigin.Portal);
    const groupedMap = groupBy(
      footerItems.sort((a, b) => -1 * b.category.localeCompare(a.category)),
      (item) => item.category,
    );
    this.groupedFooterItems.set(Array.from(FooterComponent.generateFooterItems(groupedMap)));
  }

  private static *generateFooterItems(groupedMap): Generator<FooterItem> {
    for (const key of groupedMap.keys()) {
      yield {
        category: key,
        items: groupedMap.get(key),
      };
    }
  }
}

export interface FooterItem {
  category: FooterLinkCategory;
  items: NavigationLink[];
}
